import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Controller } from "react-hook-form";

export const MuiAutoComplete = (props) => {
  const { control, options, name, autoComplete, customChangeCB } = props;
  return (
    <Controller
      {...props}
      name={name}
      control={control}
      render={(propsSec) => (
        <Autocomplete
          autoComplete={autoComplete}
          {...propsSec}
          {...props}
          options={options}
          renderInput={(params) => (
            <div className="flex items-center">
              <div className="w-full">
                <TextField
                  {...params}
                  {...props.inputProps}
                  style={{
                    backgroundColor: "white",
                  }}
                  variant="outlined"
                />
              </div>
            </div>
          )}
          onChange={(_, data) => {
            propsSec.onChange(data);
            if (props.customChangeCB) props.customChangeCB(data);
          }}
        />
      )}
    />
  );
};
